<template>
  <div>
    <Loading v-if="loading" />
    <div v-else>
      <CInput
        type="text"
        class="newInput nameCard"
        :label="$t('manageplan.component.card.payment-method.label.name')"
        aria-placeholder="name"
        :placeholder="$t('manageplan.component.card.payment-method.placeholder.name')"
        v-model="name"
        ref="inputName"
      />
    </div>
    <div ref="card"></div>

    <div class="text-right mt-5">
      <CButton class="py-2 px-3" color="white">{{ $t('settings.planAndBilling.payment.button.backToAccount') }}</CButton>
      <CButton @click="submit()" class="py-2 px-3 ml-2" color="primary" :disabled="loading">{{
        $t('settings.planAndBilling.payment.button.changePayment')
      }}</CButton>
    </div>
  </div>
</template>

<script>
import services from '@/services.js'
import Loading from '@/components/LoadingSpinner'

export default {
  components: {
    Loading,
  },
  data() {
    return {
      stripe: null,
      elements: null,
      card: null,
      organizationId: null,
      host: window.location.host,
      protocol: window.location.protocol,
      appearance: {
        theme: 'stripe',
        rules: {
          '.Label': {
            fontSize: '1rem',
            fontWeight: 'semibold',
          },
        },
        variables: {
          colorPrimary: '#0570de',
          colorBackground: '#ffffff',
          colorText: '#30313d',
          colorDanger: '#df1b41',
          fontFamily: 'Nunito Sans, system-ui, sans-serif',
          spacingUnit: '6px',
          borderRadius: '4px',
        },
      },
      name: null,
      path: this.$route.path,
      loading: true,
      secret: null,
    }
  },
  created() {
    this.organizationId = this.$route.params.organizationId
    this.validateBillingInfo()
    this.stripe = window.Stripe(this.$configs.VUE_APP_STRIPE_PK, {
      locale: this.lang.split('-')[0],
    })
  },

  methods: {
    close() {
      this.$emit('close')
    },
    async submit() {
      // Cartão de teste 4242 4242 4242 4242 - Qualquer data e qualquer CVC
      let result = await this.confirmSetup()

      let errorMessage = null

      if (result.error) {
        switch (result.error.type) {
          case 'StripeCardError':
            // A declined card error
            console.log('error', result.error.message)
            errorMessage = result.error.message
            break
          case 'StripeRateLimitError':
            // Too many requests made to the API too quickly
            console.log('error', result.error.message)
            errorMessage = result.error.message
            break
          case 'StripeInvalidRequestError':
            // Invalid parameters were supplied to Stripe's API
            console.log('error', result.error.message)
            errorMessage = result.error.message
            break
          case 'StripeAPIError':
            // An error occurred internally with Stripe's API
            console.log('error', result.error.message)
            errorMessage = result.error.message
            break
          case 'StripeConnectionError':
            // Some kind of error occurred during the HTTPS communication
            console.log('error', result.error.message)
            errorMessage = result.error.message
            break
          case 'validation_error':
            // You probably used an incorrect API key or Your card number is incomplete
            console.log('error', result.error.message, this.$refs.card)
            errorMessage = result.error.message
            // this.hasErrorName = true
            break
          case 'invalid_request_error':
            console.log('error', result.error.message)
            errorMessage = result.error.message
            break
          case 'StripeAuthenticationError':
            // You probably used an incorrect API key
            console.log('error', result.error.message)
            errorMessage = result.error.message
            break
          case 'card_error':
            // You probably used an incorrect API key
            console.log('error', result.error.message, this.$refs.card, this.card)
            errorMessage = result.error.message
            break
          default:
            // Handle any other types of unexpected errors
            throw new Error(result)
        }

        this.$emit('error', {
          status: 'danger',
          text: errorMessage || 'erro',
        })
        return
      } else {
        let secretId = result.setupIntent.id

        services
          .editPaymentMethod(this.organizationId, secretId)
          .then((res) => this.$emit('update'))
          .catch((error) => {
            this.$emit('error', {
              status: 'danger',
              text: error.response.data.message || 'erro',
            })
          })
      }
    },

    validateBillingInfo() {
      services
        .validatebillinginfo(this.organizationId, {})
        .then((res) => {
          this.secret = res.data.data.setupSecret

          this.mountIframeStripe()
        })
        .catch((err) => {
          console.error('erro', err)
        })
    },

    mountIframeStripe() {
      this.elements = this.stripe.elements({
        clientSecret: this.secret,
        appearance: this.appearance,
      })

      this.card = this.elements.create('payment', {
        fields: {
          billingDetails: {
            name: 'auto',
          },
        },
      })

      this.card.mount(this.$refs.card)
      this.loading = false
    },

    // seti_1MwQyCE16FYrcGYsTQQ2fTeV_secret_Nhqf9c0apEcdziHXONK7YULr1LZAE78
    // seti_1MwQyCE16FYrcGYsTQQ2fTeV

    async confirmSetup() {
      return await this.stripe.confirmSetup({
        elements: this.elements,
        redirect: 'if_required',
        confirmParams: {
          // return_url: `${this.protocol}//${this.host}${this.path}`,
          payment_method_data: {
            billing_details: {
              name: this.name,
            },
          },
        },
      })
    },
  },

  computed: {
    lang() {
      return this.$store.state.lang
    },
  },

  watch: {
    lang(newValue) {
      this.card = this.elements.update({ locale: newValue.split('-')[0] })
    },
  },
}
</script>

<style>
form.form-group .nameCard input.form-control {
  outline: 0 !important;
  border-width: 1px !important;
  border-color: #0573e180 !important;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 6px rgba(0, 0, 0, 0.02), 0 0 0 3px #0573e140, 0 1px 1px 0 #00000014 !important;
}
</style>
